module.exports = __webpack_public_path__ + "static/media/ya-mail-logo.788a5aeb.png";